/**
 * `/klienci/archiwum` — KANON 03, the surface off the roster.
 *
 * A wiring declaration. The guard is `_shell`'s, and there is no loader for the reason the other
 * routes state: the reads belong to the slice's own hooks, and a loader would fetch the same two
 * pages a second time outside the component that holds them.
 *
 * The static segment beats `/klienci/$clientId` — TanStack Router ranks a literal above a dynamic
 * parameter — so this path never resolves to a client whose id is the word "archiwum".
 */

import { createFileRoute } from '@tanstack/react-router';

import { ClientArchiveScreen } from '~/pages/client-archive';

export const Route = createFileRoute('/_shell/klienci/archiwum')({
  component: ClientArchiveScreen,
});
